import React, {useEffect, useState} from 'react';
import '../styles/CallToAction.css';
import '../styles/CTAButton.css';
import {motion} from "framer-motion";
import DecorativeStripeFull from '../web_elements/decorative_stripe_full.png';
const CallToAction = () => {
    const [status, setStatus] = useState("idle");
    const [obligatoryFields, setObligatoryFields] = useState(0);
    const [name, setName] = useState('');
    const [email, setEmail] = useState("");
    const [emailErrorMessage, setEmailErrorMessage] = useState(0);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const [phone, setPhone] = useState(""); // Track phone input
    const [phoneErrorMessage, setPhoneErrorMessage] = useState(0);
    const phoneRegex = /^[0-9]{10}$/;

    const [notes, setNotes] = useState('');

    const getBackgroundColor = (status) => {
        return status === "success"
            ? "#28a745" // Green for success
            : status === "error"
                ? "#dc3545" // Red for error
                : status === "loading"
                    ? "#4fb8ff" // Blue for loading
                    : status === "idle"
                        ? "#0E486F" // Gray for idle
                        : "#0E486F"; // Default fallback
    };

    const handleNameChange = (e) => {
        setName(e.target.value);
    }

    const handleEmailChange = (e) => {
        const input = e.target.value;
        setEmail(input);
        //console.log(input)
        // Validate email
        if (!emailRegex.test(input) && input !== "") {
            setEmailErrorMessage(1)
        } else {
            setEmailErrorMessage(0)
        }
    };

    const handlePhoneChange = (e) => {

        const input = e.target.value;
        console.log(input)
        if (input === "") {
            setPhoneErrorMessage(0)
        }
        setPhone(input);
        //console.log(input)
        //console.log(input.length)
        let doesInclude = input.includes('+')
        if (doesInclude) {
            if (input.length === 13) {
                setPhoneErrorMessage(0)
            }
        }
        if (input.length > 9 && !doesInclude && input.length < 13) {
            setPhoneErrorMessage(0)
        }
        if (input.length < 10 && input !== "") {
            setPhoneErrorMessage(1)
        }

    };

    const submitData = async () => {
        try {
            const data = {
                userAgent: navigator.userAgent,
                name: name,
                email: email,
                phone: phone,
                notes: notes,
            };
            if (data['notes'] === undefined) {
                data['notes'] = " ";
            }
            console.log('sending: ', data)
            console.log(process.env.REACT_APP_POST_DATA)
            const response = await fetch(process.env.REACT_APP_POST_DATA, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },

                body: JSON.stringify(data),
            });

            return response.json();
        } catch (error) {
            console.error("Error submitting form:", error);
        }
        setTimeout(() => setStatus("idle"), 5000);
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (name === "" || phone === "" || email === "") {
            setObligatoryFields(1)
        }
        //console.log(name !== "" && phone !== "" && email !== "")
        if (name !== "" && phone !== "" && email !== "") {
            setObligatoryFields(0);
            setStatus("loading");
            const response = await submitData();
            if(response === undefined){
                console.log('no-answer');
                setStatus("error");
            }
            else{
                console.log(response);
                if (response.message !== undefined && response.message === "1")
                {
                    setStatus("success");
                }
                else {
                    setStatus("error");
                }
            }
        }
    };

    return (
        <div id="CallToAction-container">
            <div className="input-field">
                <div className="rounded-textbox-container">
                    <p className="overtitle">Собствено име:</p>
                    <input type="text" onChange={handleNameChange} className="rounded-textbox" placeholder=""/>
                </div>
            </div>
            <div className="input-field">
                <div className="rounded-textbox-container">
                    <p className="overtitle">Електронна поща:</p>
                    {emailErrorMessage ? <div className="error">Невалиден e-mail адрес!</div> : null}
                    <input type="text" id="email" onChange={handleEmailChange} className="rounded-textbox"
                           placeholder=""/>
                </div>
            </div>
            <div className="input-field">
                <div className="rounded-textbox-container">
                    <p className="overtitle">Телефон:</p>
                    {phoneErrorMessage ? <div className="error">Невалиден номер!</div> : null}
                    <input type="text" onChange={handlePhoneChange} className="rounded-textbox" placeholder=""/>
                </div>
            </div>
            <div className="input-field">
                <div className="rounded-textbox-container">
                    <p className="overtitle">Бележки:</p>
                    <textarea type="text" className="rounded-textbox-belejki" placeholder=""/>
                </div>
            </div>
            {obligatoryFields ? <div className="warning">Моля, оставете име, телефон и имейл.</div> : null}
            <div id="CTAButton">
                <motion.button
                    onClick={handleSubmit}
                    className={`cta-button ${status}`}
                    whileHover={{scale: status === "idle" ? 1.1 : 1}} // Enlarge only when idle
                    whileTap={{scale: 0.9}} // Slight shrink on click
                    animate={{
                        backgroundColor: getBackgroundColor(status)
                    }}
                    style={{
                        border: "solid black 4px white",
                        width: "55vw",
                        height: "15vh",
                        fontFamily: "DIN Condensed",
                        borderRadius: "21px",
                        fontSize: "1.5rem",
                        color: "#fff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                    }}
                >
                    {status === "loading" ? (
                        <motion.div
                            className="loader"
                            animate={{rotate: 360}}
                            transition={{repeat: Infinity, duration: 1}}
                            style={{
                                border: "4px solid #fff",
                                borderTop: "4px solid transparent",
                                borderRadius: "21px",
                                width: "50px",
                                height: "50px",
                            }}
                        />
                    ) : status === "success" ? (
                        "✔ Получено"
                    ) : status === "error" ? (
                        "✖"
                    ) : (
                        "СВЪРЖИ СЕ"
                    )}
                </motion.button>
            </div>
        </div>
    );
};
export default CallToAction;